import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * @class AnimationGroup
 *
 * A wrapper object for simulating a GroupEffect and managing multiple animations.
 * See: https://www.w3.org/TR/web-animations-2/#grouping-and-synchronization
 */
export class AnimationGroup {
  constructor(animations, options) {
    _defineProperty(this, "animations", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "ready", void 0);
    this.animations = animations;
    this.options = options;
    this.ready = (options == null ? void 0 : options.measured) || Promise.resolve();
  }
  getProgress() {
    var _this$animations$;
    return ((_this$animations$ = this.animations[0]) == null || (_this$animations$ = _this$animations$.effect) == null ? void 0 : _this$animations$.getComputedTiming().progress) || 0;
  }
  async play(callback) {
    await this.ready;
    for (const animation of this.animations) {
      animation.play();
    }

    // TODO: Wait for all animations to be ready, using allSettled to handle rejections gracefully
    // await Promise.allSettled(
    await Promise.all(this.animations.map(animation => animation.ready));
    if (callback) {
      callback();
    }
  }
  pause() {
    for (const animation of this.animations) {
      animation.pause();
    }
  }
  async reverse(callback) {
    await this.ready;
    for (const animation of this.animations) {
      animation.reverse();
    }

    // TODO: Wait for all animations to be ready, using allSettled to handle rejections gracefully
    // await Promise.allSettled(
    await Promise.all(this.animations.map(animation => animation.ready));
    if (callback) {
      callback();
    }
  }
  progress(p) {
    for (const animation of this.animations) {
      const {
        activeDuration
      } = animation.effect.getComputedTiming();
      const {
        delay
      } = animation.effect.getTiming();
      animation.currentTime = ((delay || 0) + (activeDuration || 0)) * p;
    }
  }
  cancel() {
    for (const animation of this.animations) {
      animation.cancel();
    }
  }
  setPlaybackRate(rate) {
    for (const animation of this.animations) {
      animation.playbackRate = rate;
    }
  }
  async onFinish(callback) {
    try {
      await Promise.all(this.animations.map(animation => animation.finished));
      callback();
    } catch (_error) {
      console.warn('animation was interrupted - aborting onFinish callback - ', _error);
    }
  }
  get finished() {
    return Promise.all(this.animations.map(animation => animation.finished));
  }
  get playState() {
    var _this$animations$2;
    return (_this$animations$2 = this.animations[0]) == null ? void 0 : _this$animations$2.playState;
  }
}
//# sourceMappingURL=AnimationGroup.js.map